import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';
import type { ConnectCallback } from '../../../types.tsx';

const REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';

/**
 * Refresh an issue page without reloading the browser.
 *
 * This is helpful when your add-on updates information about an issue in the background.
 * @memberof module:Jira
 * @method refreshIssuePage
 * @noDemo
 * @example
 * AP.jira.refreshIssuePage();
 */
export const refreshIssuePage = (): void => {
	const event = new CustomEvent(REFRESH_ISSUE_PAGE_EVENT);

	getAnalyticsWebClientPromise().then((analyticsClient) => {
		analyticsClient.getInstance().sendTrackEvent({
			source: 'jiraConnect',
			actionSubject: 'refreshIssuePage',
			action: 'called',
			attributes: {
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				isSpa: !!window.__SPA__,
			},
		});
	});

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	document.dispatchEvent(event);
};

/**
 * Update glance component on new Jira Issue View. Not yet public.
 * @ignore
 */
export const updateIssueGlance = (data: unknown, callback: ConnectCallback): void => {
	const event = new CustomEvent(UPDATE_ISSUE_GLANCE_EVENT, {
		detail: [
			null,
			{
				addonKey: callback._context.extension.addon_key,
				moduleKey: callback._context.extension.key,
				data,
			},
		],
	});

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	document.dispatchEvent(event);
};
